<template>
		<div class="row">
			<div class="col-md-4">
				<ListItem title="STOCK VALUE BY AREA" unit="M" div="1000000" :data="stock.area" itemcol="SalesArea" valuecol="StockValue"/>
			</div>
			<div class="col-md-8">
				<BarCard title="STOCK VALUE BY DIVISION (M)" :data="stock.divchart" :width="500" :height="280"/>
			</div>

			<BarCard title="STOCK VALUE BY DEPARTMENT (M)" :data="stock.deptchart" :width="500" :height="280"/>

			<div class="col-md-6">
				<BarCard title="TOP ITEM OOS (%)" :data="stock.oos.item" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="NO OF STORE TOP ITEM OOS" :data="stock.oos.store" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="TOP ITEM POTENTIAL OOS (%)" :data="stock.poos.item" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="NO OF STORE TOP ITEM POTENTIAL OOS" :data="stock.poos.store" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="STOCK AGING BY AREA (M)" :data="stock.agingarea" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="STOCK AGING BY DIVISION (M)" :data="stock.agingdiv" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="NOT SOLD ITEM BY AREA (M)" :data="stock.notsoldarea" :width="500" :height="280"/>
			</div>
			<div class="col-md-6">
				<BarCard title="NOT SOLD ITEM BY DIVISION (M)" :data="stock.notsolddiv" :width="500" :height="280"/>
			</div>

			<BarCard title="DETENTION RATE (%)" :data="stock.detentionrate" :width="500" :height="280"/>

		</div>

</template>

<script>
import Bright from '@/components/page/Bright.js'
import ListItem from '@/views/pages/ListItem.vue'
import BarCard from '@/views/pages/BarCard.vue'

export default{
	extends: Bright,
	components:{
		ListItem,
		BarCard,
    },
    mounted(){
		this.loadStock();
		this.loadOOS();
		this.loadDetentionRate();
		this.$emit('childrenRoute')
    },
    methods:{	
    },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }
</style>